import React from 'react'
import styled from 'styled-components'
import SectionTitle from './SectionTitle'

import { rhythm, media } from '../utils/style-utils'

const Content = styled.div`
  text-align: center;
  max-width: 20em;
  margin: 0 auto;
  line-height: 1.2;
  margin-top: ${rhythm(1)};

  ${media.tablet`
    margin-top: ${rhythm(2)};
    font-size: 1.6rem;
  `};

  a {
    font-weight: bold;
    color: inherit;
  }
`

const Wrapper = styled.section`
  && {
    margin: ${rhythm(2)} auto;

    ${media.tablet`
      margin-top: ${rhythm(5)};
      margin-bottom: ${rhythm(5)};
    `};
  }
`

const Paragraph = props => {
  const { data } = props
  return (
    <Wrapper className="l-constrained">
      <SectionTitle>{data.frontmatter.title}</SectionTitle>
      <Content dangerouslySetInnerHTML={{ __html: data.html }} />
    </Wrapper>
  )
}

export default Paragraph



// WEBPACK FOOTER //
// ./src/components/Paragraph.js